<template>
  <div class="box mt-5">
    <div class="row">
      <div class="col-md-12 m-3">
        <h3> Rooms </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form class="form" v-on:submit.prevent="saveRoom">

          <fieldset>

            <div class="form-wrap">

              <div>
                <label for="name">Name</label>
                <input type="text" required id="name" v-model="newRoom.name">
              </div>

              <div>
                <label for="board-basis">Board basis</label>
                <input type="text" required id="board-basis" v-model="newRoom.board_basis">
              </div>

              <div>
                <label for="occupancy">Occupancy</label>
                <input id="occupancy" required type="number" v-model="newRoom.occupancy" min="1">
              </div>

              <div>
                <label for="is-special-instance">Is Special</label>
                <label class="switch">
                  <input id="is-special-instance" type="checkbox" v-model="newRoom.is_special">
                  <span class="switch__slider"></span>
                </label>
              </div>
              
              <div class="form-submit-inline">
                <div v-if="this.getLoadStatus">
                  <button type="submit" class="button" disabled><span>Adding room...</span></button>
                </div>
                <div v-else>
                  <button type="submit" class="button" v-if="userRole == 1"><span>Add room</span></button>
                </div>
              </div>
            </div>

          </fieldset>

        </form>

        <table class="table" cellspacing="0" cellpadding="0" v-if="accommodationRooms">
          <thead v-if="accommodationRooms.length > 0">
            <tr>
              <th style="width: 30px;"></th>
              <th>Room name</th>
              <th>Board basis</th>
              <th>Occupancy</th>
              <th>Special ?</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="(room, index) of accommodationRooms" 
              :key="room.id"
              draggable="true"
              @dragstart="handleDragStart($event, index)"
              @dragover.prevent="handleDragOver($event, index)"
              @drop="handleDrop($event, index)"
              @dragend="handleDragEnd"
              :class="{ 'dragging': draggedIndex === index, 'drag-over': dragOverIndex === index }"
              style="cursor: move;"
            >
              <td style="cursor: grab; user-select: none; width: 30px; text-align: center;" title="Drag to reorder">
                <span style="font-size: 18px; color: #999;">☰</span>
              </td>
              <td><input type="text" title="Room Name" v-model="room.name" v-on:change="updateRoom(room, $event)" @mousedown.stop></td>
              <td><input type="text"  title="Board basis" v-model="room.board_basis" v-on:change="updateRoom(room, $event)" @mousedown.stop></td>
              <td><input class="room-table-price-input" type="number" min="1" title="Occupancy" v-model="room.occupancy" v-on:change="updateRoom(room, $event)" @mousedown.stop></td>
              <td>{{ (room.is_special) ? 'Yes' : '--' }}</td>
              <td>
                <router-link class="button button--small" :to="{ name: 'accommodation-room-edit', params: { id: room.id }}">Manage Availability</router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'AccommodationRoomsEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data () {
    return {
      accommodationRooms: null,
      errors: null,
      newRoom: {},
      draggedIndex: null,
      dragOverIndex: null,
    }
  },
  created () {
    this.getAccommodationRoom()
  },
  watch: {
    '$route': 'getAccommodationRoom'
  },
  methods: {
    getAccommodationRoom () {
      console.log("A "+this.$route.params.id)
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/rooms/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        // Sort rooms by order field if it exists, otherwise maintain original order
        const rooms = response.data || []
        this.accommodationRooms = rooms.sort((a, b) => {
          const orderA = a.order !== null && a.order !== undefined ? a.order : 999
          const orderB = b.order !== null && b.order !== undefined ? b.order : 999
          return orderA - orderB
        })
        this.newRoom.order = this.accommodationRooms.length + 1
        this.$store.dispatch('setLoadStatus')
      })
    },
    saveRoom () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'accommodation/rooms/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(this.newRoom),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.newRoom = {};
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.getAccommodationRoom()
        this.$store.dispatch('setLoadStatus')
      })
    },
    updateRoom(room, event) {
        fetch(this.$api + 'accommodation/rooms/' + room.id + '/update', {
          method: 'POST',
          body: JSON.stringify(room),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.getAccommodationRoom()
          this.errors = response.errors
          if(response.success) {
            this.$notify({
              type: 'success',
              title: event.target.title + ' updated'
            })
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
        })
      },
    handleDragStart(event, index) {
      this.draggedIndex = index
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/html', event.target)
      event.target.style.opacity = '0.5'
    },
    handleDragOver(event, index) {
      if (this.draggedIndex !== null && this.draggedIndex !== index) {
        this.dragOverIndex = index
      }
    },
    handleDrop(event, dropIndex) {
      event.preventDefault()
      
      if (this.draggedIndex === null || this.draggedIndex === dropIndex) {
        return
      }

      const draggedRoom = this.accommodationRooms[this.draggedIndex]
      const rooms = [...this.accommodationRooms]
      
      // Remove the dragged item from its original position
      rooms.splice(this.draggedIndex, 1)
      
      // Insert it at the new position
      rooms.splice(dropIndex, 0, draggedRoom)
      
      // Update the order field for all rooms based on their new position
      const updatedRooms = rooms.map((room, index) => {
        return {
          ...room,
          order: index + 1
        }
      })
      
      this.accommodationRooms = updatedRooms
      this.updateRoomsOrder(updatedRooms)
      this.draggedIndex = null
      this.dragOverIndex = null
    },
    handleDragEnd(event) {
      event.target.style.opacity = ''
      this.draggedIndex = null
      this.dragOverIndex = null
    },
    updateRoomsOrder(rooms) {
      // Update each room's order field
      rooms.forEach((room, index) => {
        const roomToUpdate = {
          ...room,
          order: index + 1
        }
        
        fetch(this.$api + 'accommodation/rooms/' + room.id + '/update', {
          method: 'POST',
          body: JSON.stringify(roomToUpdate),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if (response.success) {
            // Only show notification for the last update to avoid spam
            if (index === rooms.length - 1) {
              this.$notify({
                type: 'success',
                title: 'Room order updated'
              })
            }
          } else {
            this.$notify({
              type: 'error',
              title: response.message || 'Failed to update room order'
            })
          }
        })
        .catch(error => {
          console.error('Error updating room order:', error)
          this.$notify({
            type: 'error',
            title: 'Error updating room order'
          })
        })
      })
    }
  }
}
</script>

<style scoped>
tbody tr.dragging {
  opacity: 0.5;
}

tbody tr.dragging td:first-child span {
  cursor: grabbing;
}

tbody tr.drag-over {
  border-top: 2px solid #007bff;
}

tbody tr {
  transition: opacity 0.2s, border-color 0.2s;
}

tbody tr:hover {
  background-color: #f8f9fa;
}

tbody tr:hover td:first-child span {
  color: #007bff;
}
</style>
